import BaseError from './base-error'

class ValidationError extends BaseError {
}

export default ValidationError
